import { ReadonlyUint8Array } from '../../types';

/*
    $Cn01=$20
    $Cn03=$00
    $Cn05=$03
    $Cn07=$00 Smartport / $3C Disk controller
*/

export const rom = new Uint8Array([
    0xa2,0x20,0xa2,0x00,0xa2,0x03,0xa2,0x00,
    0x20,0x58,0xff,0xba,0xbd,0x00,0x01,0x8d,
    0xf8,0x07,0x0a,0x0a,0x0a,0x0a,0xa8,0xb9,
    0x80,0xc0,0x4a,0xb0,0x11,0xa5,0x00,0xd0,
    0x0a,0xa5,0x01,0xcd,0xf8,0x07,0xd0,0x03,
    0x4c,0xba,0xfa,0x4c,0x00,0xe0,0xa2,0x01,
    0x86,0x42,0xca,0x86,0x46,0x86,0x47,0x86,
    0x44,0xa2,0x08,0x86,0x45,0xad,0xf8,0x07,
    0x48,0x48,0xa9,0x47,0x48,0xb8,0x50,0x0b,
    0x68,0x0a,0x0a,0x0a,0x0a,0xaa,0x4c,0x01,
    0x08,0x00,0x00,0x4c,0x59,0xc7,0x4c,0x59,
    0xc7,0xa5,0x00,0x48,0xa9,0x60,0x85,0x00,
    0x20,0x00,0x00,0xba,0xbd,0x00,0x01,0x0a,
    0x0a,0x0a,0x0a,0xaa,0x68,0x85,0x00,0xbd,
    0x81,0xc0,0x30,0xfb,0x48,0xbd,0x82,0xc0,
    0x48,0xbd,0x83,0xc0,0x48,0xbd,0x84,0xc0,
    0x6a,0x7a,0xfa,0x68,0x60,0x00,0x00,0x00,
    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
    0x00,0x00,0x00,0x00,0x00,0x00,0xd7,0x53,
]) as ReadonlyUint8Array;
